import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeMarketingCampaignCreate,
  detail: routeMarketingCampaignDetail,
  home: routeMarketingCampaignsHome,
  root: routeMarketingCampaignsRoot,
} = createDoctypeRoutes({
  createName: 'new-marketing-campaign',
  createPath: 'new-marketing-campaign',
  detailName: 'marketing-campaign-detail',
  doctype: DOCTYPES.MARKETING_CAMPAIGN,
  homeName: 'marketing-campaigns',
  path: 'campaigns',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/marketingCampaigns/AddMarketingCampaign.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/marketingCampaigns/ViewMarketingCampaign.vue'),
    list: async () =>
      await import('@/components/viewsExternal/marketingCampaigns/MarketingCampaignsView.vue'),
  },
})

export {
  routeMarketingCampaignCreate,
  routeMarketingCampaignDetail,
  routeMarketingCampaignsHome,
  routeMarketingCampaignsRoot,
}
